import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ScanScore } from 'src/interfaces/ScanScore';
import { getScansScore } from 'src/services/scan/ScansService';

export const useGetScansScore = (ids: string[], viewId?: string): UseQueryResult<ScanScore[]> => {
	return useQuery<ScanScore[], Error>({
		queryKey: ['scans-score', ids.sort(), viewId ?? 'none'],
		queryFn: () => getScansScore(ids, viewId),
		enabled: !!ids?.length
	});
};
